var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewsletterMailSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4C2.3457031,4,1,5.3457031,1,7v18c0,1.6542969,1.3457031,3,3,3h24c1.6542969,0,3-1.3457031,3-3V7 C31,5.3457031,29.6542969,4,28,4z M22.7070312,18.2929688l-1.4140625,1.4140625L27.5859375,26H4.4140625l6.2929688-6.2929688 l-1.4140625-1.4140625L3,24.5859375V7.4140625l8.8789062,8.8789062C12.9638672,17.3779297,14.4658203,18,16,18 s3.0361328-0.6220703,4.1210938-1.7070312L29,7.4140625v17.171875L22.7070312,18.2929688z M4.4140625,6h23.171875 l-8.8789062,8.8789062C17.9941406,15.5917969,17.0078125,16,16,16s-1.9941406-0.4082031-2.7070312-1.1210938L4.4140625,6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsletterMailSmall);
export default __webpack_public_path__ + "static/media/newsletter-mail--small.90ec9d2cdf70f32d62292a04316bb145.svg";
export { ForwardRef as ReactComponent };